export default {
  loading: true,
  listProducts: [],
  fieldProducts: [
    { key: 'valor', label: 'Código' },
    { key: 'descripcion', label: 'Nombre' },
    { key: 'actions', label: '' },
  ],
  pagination: {
    items: 0,
    pages: 0
  },
};
